import React from 'react';
import { useLanguage } from '../i18n';
import Multiline from './Multiline';
import Certification from './Certification';

export const RON_LINKEDIN_URL = 'https://www.linkedin.com/in/ron-tamerin';

/**
 * Education work, an attributed founder portrait and credentials, and R&D seals.
 */
const About: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section className="lp-about lp-wrap" id="about" aria-labelledby="about-heading">
      <div className="lp-about-label">
        <figure className="lp-about-photo">
          <img
            src="/ron-tamerin-dzpg-panel-2026.jpg"
            alt={t.about.photoAlt}
            width={960}
            height={1200}
            loading="lazy"
          />
          <figcaption>
            <strong>{t.about.founderName}</strong>
            <span>{t.about.founderTitle}</span>
          </figcaption>
        </figure>
      </div>

      <div className="lp-about-copy">
        <h2 id="about-heading">
          <Multiline text={t.about.heading} />
        </h2>
        <p>{t.about.body}</p>
        <p>{t.about.teaching}</p>
        <ul className="lp-about-points" data-testid="about-points">
          {t.about.points.map((point) => (
            <li key={point.text}>
              <span>
                {point.text}
                {point.links && point.links.length > 0 && (
                  <span className="lp-point-links">
                    {point.links.map((link) => (
                      <React.Fragment key={link.href}>
                        {' '}
                        <a href={link.href} target="_blank" rel="noopener noreferrer">
                          {link.label} ↗
                        </a>
                      </React.Fragment>
                    ))}
                  </span>
                )}
              </span>
            </li>
          ))}
        </ul>
        <a className="lp-text-link" href={RON_LINKEDIN_URL} target="_blank" rel="noopener noreferrer">
          {t.about.linkedinLabel} <span aria-hidden="true">↗</span>
        </a>
        <Certification />
      </div>
    </section>
  );
};

export default About;
